import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Route, Redirect } from 'react-router-dom';
import { withRouter } from 'react-router-dom';
import ForbiddenDialog from "../../components/ForbiddenDialog/ForbiddenDialog";
import { logout } from "../../actions/authActions";
import LoadingDialog from "../../components/LoadingDialog/LoadingDialog";
import SomethingWentWrongDialog from '../../components/SomethingWentWrongDialog';

export class ProtectedRoute extends Component {
    logOut = () => {
        this.props.dispatch(logout());
    };

    goHome = () => {
        this.props.history.push('/');
    };

    reload = () => {
        window.location.reload();
    };

    render() {
        if (!this.props.isAuthenticated) {
            return <Redirect to="/login" />
        }

        // If we are still getting the current user, show a progress indicator
        if (this.props.currentUser.isFetching) {
            return <LoadingDialog />
        }

        if (this.props.currentUser.active === null) {
            return <SomethingWentWrongDialog onReloadClick={this.reload} onLogOutClick={this.logOut} />
        }

        if (this.props.currentUser.active === false) {
            return <ForbiddenDialog onDismissClick={this.logOut} />
        }

        // If we are still getting the current user roles, show a progress indicator
        if (this.props.currentUserRoles.isFetching) {
            return <LoadingDialog />
        }

        if (this.props.currentUserRoles.isAdmin === null ||
            this.props.currentUserRoles.isSketchTech === null ||
            this.props.currentUserRoles.isSketchOsAdmin === null) {
            return <SomethingWentWrongDialog onDismissClick={this.reload} />
        }

        if (
            this.props.currentUserRoles.isAdmin === false &&
            this.props.currentUserRoles.isSketchOsAdmin === false &&
            this.props.currentUserRoles.isSketchTech === false
        ) {
            return <ForbiddenDialog onDismissClick={this.logOut} />
        }

        if (this.props.sketchOsAdminRequired && (!this.props.currentUserRoles.isAdmin && !this.props.currentUserRoles.isSketchOsAdmin)) {
            return <ForbiddenDialog onDismissClick={this.goHome} />
        }

        return <Route
            exact={this.props.exact}
            path={this.props.path}
            component={this.props.component}
        />
    }
}

ProtectedRoute.propTypes = {
    dispatch: PropTypes.func.isRequired,
    isAuthenticated: PropTypes.bool.isRequired,
    path: PropTypes.string.isRequired,
    component: PropTypes.func.isRequired,
    exact: PropTypes.bool,
    sketchOsAdminRequired: PropTypes.bool,
    currentUser: PropTypes.shape({
        isFetching: PropTypes.bool.isRequired,
        userName: PropTypes.string,
        firstName: PropTypes.string,
        lastName: PropTypes.string,
        active: PropTypes.bool,
    }).isRequired,
    currentUserRoles: PropTypes.shape({
        isFetching: PropTypes.bool.isRequired,
        isAdmin: PropTypes.bool.isRequired,
        isSketchOsAdmin: PropTypes.bool.isRequired,
        isSketchTech: PropTypes.bool.isRequired,
    }).isRequired,
    history: PropTypes.shape({
        push: PropTypes.func.isRequired,
    }).isRequired,
};

PropTypes.defaultProps = {
    exact: false,
    sketchOsAdminRequired: false,
};

const mapStateToProps = (state) => {
    const { auth, currentUser, currentUserRoles } = state;
    const { isAuthenticated } = auth;

    return {
        isAuthenticated,
        currentUser,
        currentUserRoles,
    }
};

export default withRouter(connect(mapStateToProps)(ProtectedRoute));
